export const translations = {
  es: {
    hero: {
      badge: 'Atención Mamás',
      title1: 'Tú o Tu Hijo Pueden ',
      title2: 'Ganar Dinero con Su Voz!',
      subtitle:
        'Soy mamá de una actriz de voz que hoy trabaja con grandes plataformas. Esta es la guía que me hubiera gustado tener cuando empezamos — te enseño paso a paso cómo tú o tu hijo pueden entrar al mundo del doblaje, sin experiencia, sin conexiones, desde casa.',
      highlight1: 'Guía para mamás que quieren ayudar a sus hijos ',
      highlight2: 'o empezar ellas mismas',
      highlight3: ' en el mundo del doblaje',
      cta: '¡QUIERO LA GUÍA AHORA! — Solo $14.97',
      check1: 'Descarga inmediata',
      check2: 'Garantía de 30 días',
      check3: 'Acceso de por vida',
      badge1Title: 'Pueden Ganar Hasta',
      badge1Sub: '$500 por hora de trabajo en doblaje',
      badge2Title: 'Trabajo Remoto',
      badge2Sub: 'desde cualquier parte del mundo, 100% online',
      productImage:
        'https://cdn.magicpatterns.com/uploads/sdyiXi8zsQGQUvteJjYLSL/Gemini_Generated_Image_31buj731buj731bu.png',
      ctaLink:
        'https://voice-over-47.myshopify.com/products/doblaje-de-voz?variant=51349316305184',
    },
    problem: {
      title1: '¿Te Identificas, ',
      title2: 'Mamá?',
      card1Title: 'Preocupación',
      card1Desc:
        'Sabes que tú o tu hijo tienen talento, pero no sabes cómo dar el primer paso en el mundo del doblaje de voz.',
      card2Title: 'Confusión',
      card2Desc:
        'Has buscado información, pero todo está en inglés, es caro, o no explica cómo empezar desde cero en español.',
      card3Title: 'Urgencia Económica',
      card3Desc:
        'Necesitas una fuente de ingresos extra para tu familia. Imagina que tú o tu hijo pudieran generar dinero con su voz.',
      alertTitle: 'No estás sola',
      alertDesc:
        'Miles de mamás están en la misma situación. La industria del doblaje necesita voces nuevas — y tú puedes abrir esa puerta para ti o para tu hijo.',
    },
    solution: {
      badge: '¡Edición 2026! Español',
      subtitle: 'De Mamá a Mamá',
      title1: 'La Guía Que Yo Hubiera Querido Tener',
      title2: 'La Guía Definitiva de Doblaje para Ti y Tu Familia',
      desc: 'Cuando mi hija empezó en el voice over, no existía nada así en español. Por eso la creé. Esta guía tiene todo lo que necesitas para que tú o tu hijo den el primer paso hacia su primera grabación profesional — o los dos juntos.',
      f1Title: 'Técnica Vocal',
      f1Desc:
        'Ejercicios de respiración, proyección y claridad — para adultos y jóvenes por igual.',
      f2Title: 'Interpretación y Actuación',
      f2Desc:
        'Cómo leer guiones con emoción real — perfecto para doblaje de animación y comerciales.',
      f3Title: 'Primeros Clientes',
      f3Desc:
        'Cómo conseguir las primeras audiciones y trabajos pagados, para ti o para tu hijo.',
      f4Title: 'Estudio en Casa',
      f4Desc:
        'Monta un mini estudio de grabación con menos de $50. Sin complicaciones.',
      cta: 'Sí, Quiero Empezar Hoy',
    },
    bonuses: {
      badge: 'Oferta Limitada',
      title1: '¡Regalos Exclusivos ',
      title2: 'Gratis Para Ti!',
      desc: 'Si ordenas hoy, te llevas estos 3 bonos de alto valor sin costo adicional — perfectos para que tú o tu hijo practiquen desde hoy.',
      free: 'GRATIS',
      b1Title: 'Bono #1 — Ejercicios de Dicción para Toda la Familia',
      b1Value: 'Valor: $29',
      b1Desc: 'Una rutina práctica para:',
      b1f1: 'Mejorar claridad al hablar',
      b1f2: 'Ejercicios divertidos para practicar solos o en familia',
      b1f3: 'Eliminar muletillas y ruidos',
      b1f4: 'Sonar profesional a cualquier edad',
      b1Footer: 'Solo 10–15 minutos al día. ¡Pueden hacerlo juntos!',
      b1Image:
        'https://cdn.magicpatterns.com/uploads/3tkvgj9AqK3C75KqrR4sHS/Gemini_Generated_Image_lx9w6ilx9w6ilx9w.png',
      b2Title: 'Bono #2 — Cómo Crear Tu Demo Paso a Paso',
      b2Value: 'Valor: $37',
      b2Desc: 'Incluye ejemplos prácticos de:',
      b2f1: 'Demo comercial',
      b2f2: 'Demo para animación',
      b2f3: 'Ejemplos en español e inglés',
      b2Footer:
        'Para que tú o tu hijo tengan un modelo a seguir. Sin adivinar.',
      b3Title: 'Bono #3 — Guiones Listos para Practicar (Español e Inglés)',
      b3Value: 'Valor: $19',
      b3Desc: 'Guiones listos para grabar de:',
      b3f1: 'Comerciales',
      b3f2: 'Animación',
      b3f3: 'Narración',
      b3Footer: 'Pueden empezar a practicar hoy mismo.',
      b3Image:
        'https://cdn.magicpatterns.com/uploads/h1z7T2QDtK7unQrkBhMikZ/Gemini_Generated_Image_42646t42646t4264.png',
    },
    testimonials: {
      title1: 'Lo Que Dicen ',
      title2: 'Otras',
      title3: ' Mamás Como Tú',
      desc: 'Mamás reales que lo hicieron por sus hijos — y por ellas mismas.',
      t1Name: 'María G.',
      t1Role: 'Mamá de Actor de Voz Infantil',
      t1Text:
        'Mi hijo de 12 años grabó su primer comercial gracias a esta guía. ¡No lo podía creer! Ahora tiene audiciones cada semana.',
      t2Name: 'Laura P.',
      t2Role: 'Mamá y Actriz de Voz',
      t2Text:
        'Empecé pensando que era solo para mi hija, pero terminé haciéndolo yo también. ¡Ahora las dos hacemos doblaje juntas desde casa!',
      t3Name: 'Carmen S.',
      t3Role: 'Mamá Emprendedora',
      t3Text:
        'Con la urgencia económica que tenemos, esta guía fue una bendición. Por menos de $10 mi hijo ya está generando sus primeros ingresos con su voz.',
    },
    cta: {
      title: '¿Lista Para Empezar Tú o Tu Hijo?',
      desc1: 'Obtén acceso inmediato a la ',
      desc2: 'Guía de Doblaje',
      desc3: ' + los ',
      desc4: '3 Bonos Exclusivos',
      desc5:
        '. Todo lo que necesitan para empezar hoy — tú, tu hijo, o los dos.',
      priceNormal: 'Precio Normal: $97',
      offer: 'Oferta por tiempo limitado',
      btn: '¡QUIERO ACCESO AHORA!',
      f1Title: 'Garantía de 30 Días',
      f1Desc: 'En los primero 30 dias puedes descargarlo multiples veces.',
      f2Title: 'Pago Seguro',
      f2Desc: 'Tus datos están protegidos con encriptación SSL de 256-bits.',
      f3Title: 'Acceso Inmediato',
      f3Desc: 'Recibe tu acceso por email en menos de 2 minutos.',
      bundleImage:
        'https://cdn.magicpatterns.com/uploads/smPng22KwAvv8BsMspJeXK/Gemini_Generated_Image_m3nqrvm3nqrvm3nq.png',
    },
    footer: {
      desc: 'Ayudando a mamás a entrar al mundo del doblaje — ellas y sus hijos.',
      terms: 'Términos y Condiciones',
      privacy: 'Política de Privacidad',
      copyright:
        ' VozPro. Todos los derechos reservados. Este sitio no es parte de Facebook o Facebook Inc.',
      modalText:
        'Este es un texto de ejemplo para la sección legal. Aquí irían los detalles legales completos correspondientes a ',
      modalTerms: 'los términos de servicio',
      modalPrivacy: 'la política de privacidad',
      close: 'Cerrar',
    },
  },
  en: {
    hero: {
      badge: 'Attention Moms',
      title1: 'You or Your Child Can ',
      title2: 'Make Money with Your Voice!',
      subtitle:
        'I am a mom of a voice actress who now works with major platforms. This is the guide I wish I had when we started — I teach you step by step how you or your child can enter the world of dubbing, no experience, no connections, from home.',
      highlight1: 'Guide for moms who want to help their kids ',
      highlight2: 'or start themselves',
      highlight3: ' in the voice over world',
      cta: 'I WANT THE GUIDE NOW! — Only $14.97',
      check1: 'Instant download',
      check2: '30-day guarantee',
      check3: 'Lifetime access',
      badge1Title: 'You Can Earn Up To',
      badge1Sub: '$500 per hour of voice over work',
      badge2Title: 'Remote Work',
      badge2Sub: 'from anywhere in the world, 100% online',
      productImage:
        'https://cdn.magicpatterns.com/uploads/nqzNx4kWQ8bPX7YbwbYNtP/Gemini_Generated_Image_bl50d7bl50d7bl50.png',
      ctaLink:
        'https://voice-over-47.myshopify.com/products/voice-over?variant=51351128998176',
    },
    problem: {
      title1: 'Can You Relate, ',
      title2: 'Mom?',
      card1Title: 'Worry',
      card1Desc:
        "You know you or your child have talent, but you don't know how to take the first step into the voice over world.",
      card2Title: 'Confusion',
      card2Desc:
        "You've looked for information, but everything is in English, expensive, or doesn't explain how to start from scratch in Spanish.",
      card3Title: 'Financial Urgency',
      card3Desc:
        'You need an extra source of income for your family. Imagine if you or your child could make money with your voice.',
      alertTitle: 'You are not alone',
      alertDesc:
        'Thousands of moms are in the same situation. The dubbing industry needs new voices — and you can open that door for yourself or your child.',
    },
    solution: {
      badge: '2026 Edition! Spanish',
      subtitle: 'From Mom to Mom',
      title1: 'The Guide I Wish I Had',
      title2: 'The Ultimate Dubbing Guide for You and Your Family',
      desc: "When my daughter started in voice over, there was nothing like this in Spanish. That's why I created it. This guide has everything you need for you or your child to take the first step towards your first professional recording — or both of you together.",
      f1Title: 'Vocal Technique',
      f1Desc:
        'Breathing, projection, and clarity exercises — for adults and youth alike.',
      f2Title: 'Interpretation and Acting',
      f2Desc:
        'How to read scripts with real emotion — perfect for animation and commercial dubbing.',
      f3Title: 'First Clients',
      f3Desc:
        'How to get the first paid auditions and jobs, for you or your child.',
      f4Title: 'Home Studio',
      f4Desc: 'Set up a mini recording studio for under $50. No complications.',
      cta: 'Yes, I Want to Start Today',
    },
    bonuses: {
      badge: 'Limited Offer',
      title1: 'Exclusive Gifts ',
      title2: 'Free For You!',
      desc: 'If you order today, you get these 3 high-value bonuses at no additional cost — perfect for you or your child to practice starting today.',
      free: 'FREE',
      b1Title: 'Bonus #1 — Diction Exercises for the Whole Family',
      b1Value: 'Value: $29',
      b1Desc: 'A practical routine to:',
      b1f1: 'Improve speaking clarity',
      b1f2: 'Fun exercises to practice alone or as a family',
      b1f3: 'Eliminate filler words and noises',
      b1f4: 'Sound professional at any age',
      b1Footer: 'Only 10–15 minutes a day. You can do it together!',
      b1Image:
        'https://cdn.magicpatterns.com/uploads/ucG349bQPthK1iT3Ureg5e/Gemini_Generated_Image_u6zi0qu6zi0qu6zi.png',
      b2Title: 'Bonus #2 — How to Create Your Professional Voice Demo',
      b2Value: 'Value: $37',
      b2Desc: 'Includes practical examples of:',
      b2f1: 'Commercial demo',
      b2f2: 'Animation demo',
      b2f3: 'Examples in Spanish and English',
      b2Footer: 'So you or your child have a model to follow. No guessing.',
      b3Title: 'Bonus #3 — Ready-to-Practice Scripts (Spanish and English)',
      b3Value: 'Value: $19',
      b3Desc: 'Ready-to-record scripts for:',
      b3f1: 'Commercials',
      b3f2: 'Animation',
      b3f3: 'Narration',
      b3Footer: 'You can start practicing today.',
      b3Image:
        'https://cdn.magicpatterns.com/uploads/cY73HBAi2XaH5Zw26Np4GM/Gemini_Generated_Image_2eeltc2eeltc2eel.png',
    },
    testimonials: {
      title1: 'What ',
      title2: 'Other',
      title3: ' Moms Like You Say',
      desc: 'Real moms who did it for their kids — and for themselves.',
      t1Name: 'Maria G.',
      t1Role: 'Mom of Child Voice Actor',
      t1Text:
        "My 12-year-old son recorded his first commercial thanks to this guide. I couldn't believe it! Now he has auditions every week.",
      t2Name: 'Laura P.',
      t2Role: 'Mom and Voice Actress',
      t2Text:
        'I started thinking it was just for my daughter, but I ended up doing it too. Now we both do dubbing together from home!',
      t3Name: 'Carmen S.',
      t3Role: 'Entrepreneur Mom',
      t3Text:
        'With the financial urgency we have, this guide was a blessing. For less than $10 my son is already generating his first income with his voice.',
    },
    cta: {
      title: 'Ready to Start You or Your Child?',
      desc1: 'Get immediate access to the ',
      desc2: 'Dubbing Guide',
      desc3: ' + the ',
      desc4: '3 Exclusive Bonuses',
      desc5: '. Everything you need to start today — you, your child, or both.',
      priceNormal: 'Regular Price: $97',
      offer: 'Limited time offer',
      btn: 'I WANT ACCESS NOW!',
      f1Title: '30-Day Guarantee',
      f1Desc: 'In the first 30 days you can download it multiple times.',
      f2Title: 'Secure Payment',
      f2Desc: 'Your data is protected with 256-bit SSL encryption.',
      f3Title: 'Immediate Access',
      f3Desc: 'Receive your access by email in less than 2 minutes.',
      bundleImage:
        'https://cdn.magicpatterns.com/uploads/q4VKSdMhX8ppxnRwCEcbT9/Gemini_Generated_Image_qho4h5qho4h5qho4.png',
    },
    footer: {
      desc: 'Helping moms enter the dubbing world — them and their kids.',
      terms: 'Terms and Conditions',
      privacy: 'Privacy Policy',
      copyright:
        ' VozPro. All rights reserved. This site is not part of Facebook or Facebook Inc.',
      modalText:
        'This is sample text for the legal section. Here would go the full legal details corresponding to ',
      modalTerms: 'the terms of service',
      modalPrivacy: 'the privacy policy',
      close: 'Close',
    },
  },
}

export type Language = 'es' | 'en'
export type TranslationKey = keyof typeof translations.es
